<template>
  <v-layout row justify-center>
    <v-dialog v-model="value" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card tabindex="0" @keypress.native="onkeypress">
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="closeH" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Approval History</v-toolbar-title>
        </v-toolbar>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 lg12 v-for="item in data" :key="item.id">
              <v-card :class="item.approvalStatus" class="card-cst">
                <v-container fluid>
                  <v-layout row wrap>
                    <v-flex xs12 lg12>
                      <div class="tittle">
                        <v-layout row wrap>
                          <v-flex xs12 lg12>
                            {{item.level}} |
                            {{item.toUser.name}} ( {{item.toUser.nik}} )
                          </v-flex>
                        </v-layout>
                      </div>
                      <v-layout row wrap>
                        <v-flex lg10 xs12>
                          <span class="sub-header">
                            <b>{{item.approvalStatus | uppercase}}</b> |
                              Final : {{item.finalStatus | uppercase}}
                            <span class="mobile-bot">
                              | Time : {{item.approvalTime | moment('DD MMM YYYY HH:mm:ss')}}
                            </span>
                          </span>
                        </v-flex>
                        <v-flex lg2 xs12 class="pad">
                          <v-container fluid grid-list-xs>
                          <v-layout row wrap justify-space-between :class="item.approvalNote?'center-middle':'center-right'">
                            <v-flex class="p-5" lg6 xs12 v-if="item.approvalNote">
                              <v-btn block
                                @click.native.stop="noted = true; selectednote = item.approvalNote"
                                small color="green light-1" dark>
                                  <v-icon class="mr-5px" small color="white">note</v-icon>
                                  Note
                              </v-btn>
                            </v-flex>
                            <v-flex class="p-5" lg6 xs12>
                              <div class="chip-cst">
                                {{item.worklistState | uppercase}}
                              </div>
                            </v-flex>
                          </v-layout>
                          </v-container>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
              <br>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog v-model="noted" max-width="290">
      <v-card>
        <v-card-title class="headline"> <v-icon>event_note</v-icon>Note</v-card-title>
        <v-card-text>{{selectednote}}</v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      require: true
    },
    data: {
      type: [String, Array],
      required: true
    }
  },
  data: () => ({
    noted: false,
    selectednote: ''
  }),
  methods: {
    closeH () {
      this.$showApproveH({vueinstance: this, Id: '', Status: false})
    },
    onkeypress (event) {
      // ESC
      if (event.keyCode === 27) {
        this.closeH()
      }
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 599px) {
  .card-cst .container{
    padding: 15px !important;
  }
  .chip-cst{
    margin-top: 5px;
  }
  .mobile-bot{
    display: block
  }
}
.p-5{
  padding: 0 5px !important;
}
.no-margin{
  margin: 0px;
}
.tittle{
  font-size: 16px;
  font-weight: 600;
  color: #424242;
}
.sub-header{
  font-size: 11px;
  color: #9E9E9E;
}
.center-right{
  display: flex;
  justify-content: flex-end;
  align-items: right;
}
.center-middle{
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-cst{
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: 10px solid;
}
  .DRAFTED,.SUBMITTED{
    border-color: #4CAF50;
  }
  .APPROVED{
    border-color: #2196f3;
  }
  .REJECTED{
    border-color: #f44336;
  }
  .REVISION{
    border-color: #FF6F00;
  }
.mr-5px{
  margin-right: 5px
}
.chip-cst{
  padding: 5px;
  font-weight: bold;
  font-size: 12px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #2196f3;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/dialogs/ApprovalTrailHistory.vue